import {
    ChangeDetectorRef,
    Component,
    forwardRef,
    OnInit,
    ChangeDetectionStrategy,
    inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QueryObserverResult } from '@tanstack/query-core';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { CommodityDataService } from '../../services/commodity-data.service';
import { VirtualizationSettings } from '@progress/kendo-angular-dropdowns';

//<!-- FormGroup consumer -->
//<div formGroupName="common">
//    <app-car-types-filter formControlName="carTypes"></app-car-types-filter>
//</div>

//<!-- ngModel consumer -->
//<app-car-types-filter [(ngModel)]="selectedCarTypes"></app-car-types-filter>

@Component({
    selector: 'app-car-types-filter',
    templateUrl: './car-types-filter.component.html',
    styleUrls: ['./car-types-filter.component.scss'],
    imports: [AsyncPipe, LabelModule, DropDownsModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CarTypesFilterComponent),
            multi: true,
        },
    ],
})
export class CarTypesFilterComponent implements ControlValueAccessor, OnInit {
    private commodityDataService = inject(CommodityDataService);
    private cdr = inject(ChangeDetectorRef);

    public carTypesQueryResults$?: Observable<
        QueryObserverResult<string[], Error>
    >;

    public isDisabled: boolean = false;
    public value: string[] = [];
    public virtual: VirtualizationSettings = { itemHeight: 28 };

    private onChange: (value: string[]) => void = () => {};
    private onTouched: () => void = () => {};

    writeValue(value: string[]): void {
        this.value = value ?? [];
        this.cdr.markForCheck();
    }

    registerOnChange(fn: (value: string[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    handleValueChange(value: string[]): void {
        this.value = value;
        this.onChange(value);
    }

    handleBlur(): void {
        this.onTouched();
    }

    ngOnInit(): void {
        this.carTypesQueryResults$ =
            this.commodityDataService.getCarTypes().result$;
    }
}
